import { FC } from "react";
import { Column } from "../../components/containers";
import ShowCustomers from "./show-customers";

const Customers: FC = () => {
  return (
    <Column style={{ overflowY: "auto", overflowX: "hidden" }}>
      <ShowCustomers />
    </Column>
  );
};

export default Customers;
